import React, { useEffect, useRef } from "react";

function Snowflake({ left, delay }: { left: number | string; delay: number | string }) {
  const snowflakeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const duration = 1.5 + Math.random() * 2.5; // 1.5-4s (nhanh hơn 2x)
    const size = 8 + Math.random() * 12; // 8-20px (nhỏ hơn trước)
    // Random direction: -50px to +50px (lệch trái hoặc phải)
    const randomDirection = (Math.random() - 0.5) * 100;

    if (snowflakeRef.current) {
      snowflakeRef.current.style.left = `${left}%`;
      snowflakeRef.current.style.animationDuration = `${duration}s`;
      snowflakeRef.current.style.fontSize = `${size}px`;
      snowflakeRef.current.style.animationDelay = `${delay}s`;
      snowflakeRef.current.style.setProperty("--direction", `${randomDirection}px`);
    }
  }, [left, delay]);

  return (
    <div ref={snowflakeRef} className="snowflake">
      ❄
    </div>
  );
}

export default Snowflake;


